import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-lfsa-options',
  templateUrl: './lfsa-options.component.html',
  styleUrls: ['./lfsa-options.component.css']
})
export class LfsaOptionsComponent implements OnInit {

  @Output() devolverAccion = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
    
  }

  xls() {
    this.devolverAccion.emit('xls');
  }

  pdf() {
    this.devolverAccion.emit('pdf');
  }
  
  global() {
    this.devolverAccion.emit('global');
  }

  limpiar() {
    this.devolverAccion.emit('limpiar');
  }

}
